import { useEffect, useState } from 'react';

// In some cases the bf cache (https://web.dev/bfcache/) might cause some things
// not to work. This hook checks if the current content has come from a persisted
// cache or not, and runs the handler if it has come from a persisted state.
export const useBFCacheHandler = (handler: () => void) => {
  const handlePageShow = (evt: PageTransitionEvent) => {
    if (evt.persisted) {
      handler();
    }
  };

  useEffect(() => {
    window.addEventListener('pageshow', handlePageShow, false);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);
};

// useRerender: used to force re-render a component.
// Usage:
//
// const [visible, reRender] = userRerender()
// return (
//   <div>
//     <button onClick=reRender>click to rerender</button>
//     {visible && <MyComponentIWantToRerenderSometimes}
//   </div>
export const useRerender = () => {
  const [visible, setEnabled] = useState(true);

  useEffect(() => {
    if (!visible) {
      setEnabled(true);
    }
  }, [visible]);

  const reRender = () => setEnabled(false);

  return [visible, reRender] as const;
};
